import configuration from "@/utils/Config";
import { restDetailsHandler, restGetHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";

const baseUrl = configuration.backendBaseUrl;
const pictureUrl = baseUrl + "/picture";

export const requestGetPicture = createEffect({
  handler: restDetailsHandler<Blob>(pictureUrl),
});

export const requestGetPictureFromUrl = createEffect((url: string) => {
  return restGetHandler<Blob>(url)({});
});

export const requestGetOfficePictureDefault = createEffect((url: string) => {
  return restGetHandler<Blob>(url)({});
});

export const requestGetOfficeScellementDefault = createEffect((url: string) => {
  return restGetHandler<Blob>(url)({});
});
